<template>
<form @submit.prevent="submit()" class="form">
<div class="container">
 <div class="col-lg-12 tp15">
		<!-- <span class="backText" @click="backButtonClick()"> <i class="fa fa-angle-left"></i> Back</span> -->
    <span class="middleHolder">
      <span class="completedTask"><i class="tickMark fa fa-check"></i></span>
      <span class="connectingLine inprogress"></span>
      <span class="pendingTask inprogress"></span>
    </span>
   
    <div class="centerDiv">
      <span class="uploadTxt">{{ $t("message.upload_page.upload_txt") }}</span>
      <span class="metadataTxt inprogressTxt">{{ $t("message.upload_page.metadata_txt") }}</span>
    </div>
	
 </div>

 <div class="col-lg-12 tp15">
		<span class="filesAndFoldersTxt">{{ $t("message.upload_page.metadata_txt") }}</span>
		<span class="fltRight"><button type="submit" class="completeTask nextPosition">{{ $t("message.metadata_page.submit_btn") }}</button></span>
  </div>  

  <div class="metadataHolder col-lg-12 tp15">
    <div class="nometadataMessage" v-if = "this.model.dispMetadataFlag===0">You are not required to provide any Metadata updates here! Please proceed to Submit </div>
    <div class="metaDetails" v-if = "this.model.dispMetadataFlag===1">
  		<span class="markedMandatory"> <span class="star">*</span>{{ $t("message.metadata_page.mandatory_txt") }}</span>
  		<div class="mg-top-50" v-for="component in model.dynamicUiData">
  			<div class="inputHolder" v-if = "component.displayType=='textfield'" :id=component.key>
  				<span class="formKey">{{component.displayname}}<span class="star" v-if = "component.required===1" >*</span></span>
  				<input type="text"  class="textfield" :disabled="!component.iseditable"
                         v-model="form[component.key]"
                         :name=component.propertyName>
  				<span class="validationMessage">{{errorMsg[component.key]}}</span>
  			</div>
  			<div class="inputHolder" v-if = "component.displayType=='textarea'" :id=component.key>
  				<span class="formKey">{{component.displayname}}<span v-if = "component.required===1" class="star">*</span></span>
  				<textarea  rows="3" :disabled="!component.iseditable"
                         v-model="form[component.key]"
                         :name=component.propertyName class="textfield" > </textarea>
  				<span class="validationMessage">{{errorMsg[component.key]}}</span>
  			</div>
  			<div class="inputHolder" v-if = "component.displayType=='combobox'" :id=component.key>
  				<span class="formKey">{{component.displayname}}<span v-if = "component.required===1" class="star">*</span></span>
  				<select v-model="form[component.key]">
  					<option  v-for="listvalue in component.listvalues" :value="listvalue.key">{{listvalue.displayname}}</option>
  				</select>
  				<span class="validationMessage">{{errorMsg[component.key]}}</span>
  			</div>
  			<div class="inputHolder" v-if = "component.displayType=='datefield'" :id=component.key>
  				<span class="formKey">{{component.displayname}}<span v-if = "component.required===1" class="star">*</span></span>
  				<input type="date" class="textfield" v-model="form[component.key]"
                         :name=component.propertyName>
  				<span class="validationMessage">{{errorMsg[component.key]}}</span>
  			</div>
  			<div class="inputHolder" v-if = "component.displayType=='checkbox'" :id=component.key>
  				<input type="checkbox" v-model="form[component.key]"> <span class="checkKey">{{component.displayname}}</span>
  				<div class="validationMessage">{{errorMsg[component.key]}}</div>
  			</div>
  			<div class="inputHolder" v-if = "component.displayType=='number'" :id=component.key>
  				<span class="formKey">{{component.displayname}}<span v-if = "component.required===1"class="star">*</span></span>
  				<input type="number" class="textfield" v-model="form[component.key]">
  				<span class="validationMessage">{{errorMsg[component.key]}}</span>
  			</div>
  		</div>	
  	</div>
  </div>	



</div>
</form>          
</template>
<style>


.metadataHolder{
	width: 100%;
    min-height: 430px;
    background: #FFFFFF;
	box-shadow: 0 0 4px 0 rgba(0,0,0,0.20);
}
.metaDetails{
    width: 48%;
    margin: 0px auto;
    height: 100%;
    padding: 17px;
}
.inprogress{
	background: #337AB7;
}

.inprogressTxt{
	color:  #337AB7;
}

.markedMandatory{
	font-family: RobotoLightItalic;
	font-size: 13px;
	color: #000000;
	float:right;
}

.star{
	color:#C35957;
}

.metadataHolder .textfield{
	border: none;
	outline: none;
    border-bottom: 1px solid #999999;
}

.metadataHolder .textfield:focus{
	outline: none;
}

.mg-top-50{
	margin-top:50px;
}

.inputHolder{
	margin-top:20px;
}

.metadataHolder textarea{
	resize: none;
	width:100%;
}


.metadataHolder select:focus{
	outline:none;
}

.metadataHolder select{
	width: 100%;
    background: transparent;
    border: none;
    border-bottom: 1px solid #999999;
}
.formKey{
	display: inline-block;
    padding-bottom: 5px;
    font-family: robotoRegular;
	font-size: 13px;
	color: #666666;
}
.checkKey{
	font-family: robotoRegular;
	font-size: 13px;
	color: #000000;
}
.validationMessage{
	font-family: robotoRegular;
	font-size: 12px;
	color: #C35957;
}
.nometadataMessage{
	font-family: robotoRegular;
	font-size: 22px;
  text-align: center;
	color: #C35957;
  position: absolute;
  width: 600px;
  height: 500px;
  z-index: 15;
  top: 60%;
  left: 40%;
  margin: -100px 0 0 -150px;
}
</style>

<script>
  import {ERROR_MSG} from '../../store/mutation-types'
  import Vue from 'vue'
  
  export default {
    data () {
      return {
        VALIDATION_MSG: {'email': 'not a valid email id', 'alphaNumeric': 'only alphabets and numbers allowed', 'alphabets': 'only alphabets allowed', 'numeric': 'Not a valid number!'},
        form: {

        },
        'errorMsg': {

        },
        model: {
          'status': true,
          'dynamicUiData': [],
          'dispMetadataFlag': '',
          'filteredDynamicUiData': [],
          'dynamicMetadataPopupFlag': false
        }
      }
    },
    created () {
      console.log('View files:' + this.$store.getters.getUserDetails)
      var payload = { sessionid: this.$store.getters.getUserDetails }
      this.$store.dispatch('allFiles', payload).then(function () {
        // TODO: allFiles to be renamed as dropzoneconfig and files should be nested into that
        if (this.$store.getters.allFiles.dropzoneConfig.delflag === 1) {
          this.$router.push({name: 'Frozen'})
        } else {
          console.log(this.$store.getters.allFiles.dropzoneConfig.propertydata)
          this.form = {}
          this.model.dynamicUiData = JSON.parse(this.$store.getters.allFiles.dropzoneConfig.propertydata)
          for (var arrIndex = 0; arrIndex < this.model.dynamicUiData.length; arrIndex++) {
            if (this.model.dynamicUiData[arrIndex].uidispflag) {
              this.model.filteredDynamicUiData.push(this.model.dynamicUiData[arrIndex])
              this.model.dispMetadataFlag = 1
            }
          }
          if (this.model.dispMetadataFlag !== 1) {
            this.model.dispMetadataFlag = 0
          }
          this.model.dynamicUiData = this.model.filteredDynamicUiData
          for (var i = 0; i < this.model.dynamicUiData.length; i++) {
            if (this.model.dynamicUiData[i].isdefault) {
              this.form[this.model.dynamicUiData[i].key] = this.model.dynamicUiData[i].defaultvalue
            }
            if (this.$i18n.locale === 'en') {
              this.model.dynamicUiData[i].displayname = this.model.dynamicUiData[i].englishdisplayname
            } else {
              this.model.dynamicUiData[i].displayname = this.model.dynamicUiData[i].russiandisplayname
            }
            console.log(this.model.dynamicUiData)
            Vue.set(this.errorMsg, this.model.dynamicUiData[i].key, '')
          }
        }
      }.bind(this))
      .catch(function (msg) {
        this.$store.commit(ERROR_MSG, {
          type: 'error',
          title: msg,
          content: 'Sorry, hai Something went wrong. Please relaunch the URL.'
        })
      }.bind(this))
    },
    methods: {
      backButtonClick () {
        this.$router.push({name: 'New'})
      },
      hideMetadataPopup () {
        this.model.dynamicMetadataPopupFlag = false
        console.log(this.model)
      },
      validateForm (validationType, value) {
        var regex = ''
        if (validationType === 'email') {
          var emails = value.replace(/\s/g, '').split(',')
          regex = /^([a-zA-Z0-9_]+)@([a-zA-Z0-9_]+)\.([a-zA-Z]{2,5})$/
          for (var i = 0; i < emails.length; i++) {
            if (emails[i] !== '' && !regex.test(emails[i])) {
              return false
            }
          }
          return true
        } else if (validationType === 'alphaNumeric') {
          regex = /^[a-zA-Z0-9\s]+$/
          return regex.test(value)
        } else if (validationType === 'alphabets') {
          regex = /^[A-z\s]+$/
          return regex.test(value)
        } else if (validationType === 'numeric') {
          regex = /^\d+$/
          return regex.test(value)
        }
      },
      changeDateFormat (datevalue) {
        var today = new Date(datevalue)
        var dd = today.getDate()
        var mm = today.getMonth() + 1

        var yyyy = today.getFullYear()
        if (dd < 10) {
          dd = '0' + dd
        }
        if (mm < 10) {
          mm = '0' + mm
        }
        return mm + '-' + dd + '-' + yyyy
      },
      submit () {
        var isValidationFail = false
        console.log(this.model.dynamicUiData)
        for (var index in this.model.dynamicUiData) {
          var model = this.model.dynamicUiData[index]
          if (this.form[model.key] === undefined || this.form[model.key] === '') {
            console.log(this.form[model.key])
            if (model.required) {
              this.errorMsg[model.key] = model.key + ' is required'
              isValidationFail = true
              break
            }
            if (model.displayType === 'checkbox') {
              this.form[model.key] = false
            } else {
              this.form[model.key] = ''
            }
          } else {
            this.errorMsg[model.key] = ''
          }
          if (model.validation_type != null) {
            if (!this.validateForm(model.validation_type, this.form[model.key])) {
              this.errorMsg[model.key] = this.VALIDATION_MSG[model.validation_type]
              isValidationFail = true
              break
            } else {
              this.errorMsg[model.key] = ''
            }
          }
        }
        if (!isValidationFail) {
          var payload = {}
          var articleMetadataValues = {}
          var jobFlowMetadataValues = {}
          for (var indexForDate in this.model.dynamicUiData) {
            var modelData = this.model.dynamicUiData[indexForDate]
            if (modelData.displayType === 'datefield') {
              this.form[modelData.key] = this.changeDateFormat(this.form[modelData.key])
              console.log(this.form[modelData.key])
            }
            if (modelData.isjobflowlevel) {
              jobFlowMetadataValues[modelData.key] = this.form[modelData.key]
            } else {
              articleMetadataValues[modelData.key] = this.form[modelData.key]
            }
          }
          payload.sessionid = this.$store.getters.getUserDetails
          payload.status = this.model.status
          payload.jobflowmetadataid = this.model.jobflowmetadataid
          payload.metadataid = this.model.metadataid
          payload['metadata'] = articleMetadataValues
          payload['jobflowmetadata'] = []
          payload['jobflowmetadata'].push({'metadata': jobFlowMetadataValues})
          this.$store.dispatch('notify', payload).then(function () {
            this.model.dynamicMetadataPopupFlag = false
            this.$router.push({name: 'Success'})
          }.bind(this))
          .catch(function () {
            this.$store.commit(ERROR_MSG, {
              type: 'error',
              title: this.$t('message.error_popup_page.error'),
              content: this.$t('message.error_popup_page.retry_msg')
            })
          }.bind(this))
        } else {
          var elmnt = document.getElementById(model.key)
          elmnt.scrollIntoView()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Metadata.vue?f5bceb92